var isServer = false;
export var supportsPassive = false;
export function on(target, event, handler) {
    var passive = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    if (!isServer) {
        target.addEventListener(
            event,
            handler,
            supportsPassive
                ? {
                      capture: false,
                      passive: passive
                  }
                : false
        );
    }
}
export function off(target, event, handler) {
    if (!isServer) {
        target.removeEventListener(event, handler);
    }
}
